import { render, staticRenderFns } from "./SyncWithEditor.vue?vue&type=template&id=2d6cdac6&scoped=true"
import script from "./SyncWithEditor.vue?vue&type=script&lang=js"
export * from "./SyncWithEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cdac6",
  null
  
)

export default component.exports